module.exports = __webpack_public_path__ + "static/media/tipo3.6e764536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wish-list/Modal/tipo3.png
// module id = 2018
// module chunks = 0